
import React from 'react';

const pageContext = React.createContext();

const {Provider} = pageContext;


export const PageContextProvider = ({children}) => {

    const [page_state, _setPageState] = React.useState({
        edit_parameters_dialog_open: false,
        submit_session_active: false,
        admin_tokens_active: false,
        edit_token_dialog_open: false,
        edit_token_id: null,
    })

    function setPageState(state) {
        return _setPageState(state);
    };

  return (
    <Provider value={{page_state, setPageState}}>
      {children}
    </Provider>
  )
}

export const usePageContext = () => {
        return React.useContext(pageContext);
};


